// extracted by mini-css-extract-plugin
export default {"rootClassName":"cadastro-anexo-i-modal"};